const Domains = [
  {
    domain: ["ae.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["localhost"],
    code: "US",
  },
  {
    domain: ["www.rockmycart.com"],
    code: "AE",
  },
  {
    domain: "us.rockmycart.com",
    code: "US",
  },
  {
    domain: ["www.rockmycart.ae"],
    code: "AE",
  },
  {
    domain: ["ae-en.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["auh.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["auh-en.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["dxb.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["dxb-en.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["en-ae.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["en-auh.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["en-dxb.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["en-uae.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["uae.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["uae-en.rockmycart.com"],
    code: "AE",
  },
  {
    domain: ["en-ksa.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["en-sa.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["en-sar.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["en-saudi.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["ksa.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["ksa-en.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["sa.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["sa-en.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["sar.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["sar-en.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["saudi.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["saudi-en.rockmycart.com"],
    code: "SA",
  },
  {
    domain: ["canada.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["can.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["ca.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["en-canada.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["en-can.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["en-ca.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["canada-en.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["can-en.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["ca-en.rockmycart.com"],
    code: "CA",
  },
  {
    domain: ["kuwait.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kw.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kwd.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kwt.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["en-kuwait.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["en-kw.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["en-kwd.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["en-kwt.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kuwait-en.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kw-en.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kwd-en.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["kwt-en.rockmycart.com"],
    code: "KW",
  },
  {
    domain: ["oman.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["muscat.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["om.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["oma.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["omn.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["omr.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-oman.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-muscat.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-om.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-oma.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-omn.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["en-omr.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["oman-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["muscat-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["om-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["oma-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["omn-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["omr-en.rockmycart.com"],
    code: "OM",
  },
  {
    domain: ["uk.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gb.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gbr.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gbp.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["eng.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["unitedkingdom.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["britain.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["british.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["england.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-uk.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-gb.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-gbr.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-gbp.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-eng.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-unitedkingdom.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-britain.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-british.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["en-england.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["uk-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gb-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gbr-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["gbp-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["eng-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["unitedkingdom-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["britain-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["british-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["england-en.rockmycart.com"],
    code: "GB",
  },
  {
    domain: ["bahrain.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["bh.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["bhd.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["en-bahrain.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["en-bh.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["en-bhd.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["bahrain-en.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["bh-en.rockmycart.com"],
    code: "BH",
  },
  {
    domain: ["bhd-en.rockmycart.com"],
    code: "BH",
  },
];

export default Domains;
